import { render, staticRenderFns } from "./LatestInspections.vue?vue&type=template&id=5b2ca33a&scoped=true&"
import script from "./LatestInspections.vue?vue&type=script&lang=js&"
export * from "./LatestInspections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ca33a",
  null
  
)

export default component.exports